export const mixinSelect = {
  inject: { formData: { from: 'formData', default: null } },
  props: {
    items: {
      type: Array,
      required: true
    },
    handlerSearch: {
      type: Function,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Не выбрано'
    },

    isClearSearchValueOnBlur: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    searchValue: '',
    loadingItems: false,
    selectDialog: false,
    shownItems: [],
    insideWindow: true
  }),
  mounted () {
    this.shownItems = this.items
  },
  updated () {
    if (!this.searchValue) {
      this.shownItems = this.items
    }
  },
  methods: {
    async searchItems () {
      if (this.loadingItems) return

      if (!this.handlerSearch) {
        return this.searchFront()
      }

      try {
        this.loadingItems = true
        await this.handlerSearch({ search: this.searchValue || null })
        this.shownItems = this.items
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingItems = false
      }
    },

    searchFront () {
      if (this.searchValue === '') {
        this.shownItems = this.items
        return
      }

      let searchField
      if (typeof this.search === 'string' && this.search) {
        searchField = this.search
      } else if (this.itemText) {
        searchField = this.itemText
      }

      this.shownItems = this.items.filter((item) => {
        const value = searchField ? item[searchField] : item
        return value.toLowerCase().includes(this.searchValue.toLowerCase())
      })
    }
  }
}
